/// <amd-module name="Artifacts/Feed/types/Index" />

export * from "Artifacts/Feed/types/INormalizedGlobalPermission";
